import styled from "@emotion/styled";
import { Empty, Typography } from "antd";

import notFooundData from "assets/icons/notFoundData.svg";
import { FC } from "react";

interface NotFoundDataProps {
  text: string;
}

const NotFoundData : FC<NotFoundDataProps> = ({ text }) => {
    return (
      <NotFoundWrapper>
         <TextNotFoundWrapper>
           <Empty description={text} image={Empty.PRESENTED_IMAGE_SIMPLE} />
        </TextNotFoundWrapper>
      </NotFoundWrapper>
    );
};

export default NotFoundData;

const NotFoundWrapper = styled.div`
  height: 72vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #EFEFEF;
  flex-direction: column;
`;

const ImageNotFound = styled.img`
  width: 154px;
  height: auto;
`;

const TextNotFoundWrapper = styled.div`
  margin-top: 16px;
`;
